import {useLocation} from 'react-router'
import {ideationApi} from '../../../../../../api/ideationApi'
import styles from './IdeationSentiments.module.scss'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import {useEffect, useState, useMemo} from 'react'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {IDEATION} from '../../../../../../Translation/English/ideation'

interface IChartDataPoint {
  name: string
  y: number
  color: string
}

interface IChartOptions {
  chart: {
    type: string
    height: number
  }
  title: {
    text: string
  }
  plotOptions: {
    pie: {
      innerSize: string
      startAngle: number
      endAngle: number
      center: string[]
    }
  }
  series: {
    name: string
    data: IChartDataPoint[]
  }[]
}

export const IdeationSentiments: React.FC = () => {
  const wt = useWt()
  const {search} = useLocation()
  const ideationId = search ? search.substring(1) : ''
  const {data: insights} = ideationApi.useIdeationInsights(ideationId)
  const sentiments = useMemo(
    () => insights?.sentiment || [],
    [insights?.sentiment],
  )

  const colours: Record<string, string> = useMemo(
    () => ({
      'very negative': '#D32F2F',
      negative: '#F44336',
      neutral: '#FFEB3B',
      positive: '#4CAF50',
      'very positive': '#2E7D32',
      Negative: '#FF7681',
      Mixed: '#FFCB47',
      Positive: '#1BA758',
      'No Sentiment': '#D8D8D8',
    }),
    [],
  )

  const [chartOptions, setChartOptions] = useState<IChartOptions>({
    chart: {
      type: 'pie',
      height: 300,
    },
    title: {
      text: '',
    },
    plotOptions: {
      pie: {
        innerSize: '60%',
        startAngle: -90,
        endAngle: 90,
        center: ['50%', '75%'],
      },
    },
    series: [
      {
        name: 'Share',
        data: [],
      },
    ],
  })

  useEffect(() => {
    if (sentiments.length === 0) return

    const updatedData: IChartDataPoint[] = sentiments.map(elt => ({
      name: elt.type,
      y: elt.percentage,
      color: colours[elt.type],
    }))

    setChartOptions(prevOptions => ({
      ...prevOptions,
      series: [{name: 'Share', data: updatedData}],
    }))
  }, [sentiments, colours])

  return (
    <div className={styles.ideationSentiments}>
      <div className="ideation-section-title">
        {wt(IDEATION.sentimentAnalysis)}
      </div>
      <div className={styles.ideationSentimentsDiv}>
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      </div>
    </div>
  )
}
